/**
 * Service Worker 注册（主线程，任务 15a）。
 *
 * - 只在生产构建注册：dev 下 SW 的缓存会盖掉 HMR，调试体验很糟。
 * - 推到 load 之后：注册与预缓存会抢带宽，首屏优先。
 * - 失败静默：SW 只是加速与离线能力，装不上不影响功能（HTTP/非安全上下文等）。
 *
 * 返回的 Promise 恒 resolve（null=没注册/不支持/失败），交给 15b 的
 * `connectSwUpdate` 接更新事件；调用方不需要 catch。
 */
export const SW_URL = '/sw.js';

export function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!import.meta.env.PROD) return Promise.resolve(null);
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator))
    return Promise.resolve(null);
  const start = (): Promise<ServiceWorkerRegistration | null> =>
    navigator.serviceWorker.register(SW_URL, { scope: '/' }).catch(() => null);
  if (document.readyState === 'complete') return start();
  return new Promise((resolve) => {
    addEventListener('load', () => void start().then(resolve), { once: true });
  });
}
